import { useContext, useEffect } from "react";
import { ToolContext } from "../../../../context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const EoDReportWalkthrough = ({ pathname, end, start}) => {

    const {personalization_state} = useContext(ToolContext)
    const {walkthrough} = personalization_state

    const startTour = () =>{
        walkthrough.set((prev) => ({...prev, eodSalesReport:true}))
    }

    const endTour = ()=>{
        walkthrough.set((prev) => ({...prev, eodSalesReport:false}))
    }

    useEffect(() => {
        start("reports", "eod-sales-report", startTour)
        //eslint-disable-next-line
    }, []);

    const steps =[
            {
                content: "Insert the Total amount of Sales for today",
                placement: "right",
                target: "#walkthrough-eod-sales-report-step-1",
                disableBeacon: true
            },
            {
                content: "You can add notes if needed",
                placement: "right",
                target: "#walkthrough-eod-sales-report-step-2",
                disableBeacon: true
            },
            {
                content: "Click Submit",
                placement: "right",
                target: "#walkthrough-eod-sales-report-step-3",
                disableBeacon: true
            },
        ]

    return (
            <JoyrideWrapper 
                run={walkthrough.data.eodSalesReport && window.location.pathname === pathname} 
                steps={steps} 
                setter={endTour} 
                end={end}
                p_name="eod-sales-report" 
                featureName="reports"
            />
        );
}
